/**
 * J-B Weld Product Finder Drawer
 * Opens on any a[href="#matrix"] or [data-jbw-finder-open] click,
 * or if the page loads with #matrix in the URL.
 */
(function () {
  var overlay = document.getElementById('jbw-product-finder');
  if (!overlay) return;

  var closeBtn = overlay.querySelector('[data-jbw-finder-close]');
  var tabs = overlay.querySelectorAll('[role="tab"]');
  var panels = overlay.querySelectorAll('[role="tabpanel"]');
  var catBtns = overlay.querySelectorAll('.jbw-finder__cat-btn');
  var projects = overlay.querySelectorAll('.jbw-finder__project-card');
  var backBtn = overlay.querySelector('[data-jbw-finder-back]');
  var triggerEl = null;
  var scrollbarWidth = 0;

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function open(trigger) {
    triggerEl = trigger || document.activeElement;
    scrollbarWidth = getScrollbarWidth();
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = scrollbarWidth + 'px';
    overlay.hidden = false;
    resetState();
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    overlay.hidden = true;
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    if (location.hash === '#matrix') {
      history.replaceState(null, '', location.pathname + location.search);
    }
    if (triggerEl && typeof triggerEl.focus === 'function') {
      triggerEl.focus();
    }
    triggerEl = null;
  }

  function resetState() {
    // Reset tabs to first
    tabs.forEach(function (t, i) {
      t.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
    });
    panels.forEach(function (p, i) {
      p.hidden = i !== 0;
    });
    // Reset categories
    catBtns.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    projects.forEach(function (p) { p.hidden = true; });
    if (backBtn) backBtn.hidden = true;
  }

  // Tab switching
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
      panels.forEach(function (p) { p.hidden = true; });
      tab.setAttribute('aria-selected', 'true');
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = false;
    });

    tab.addEventListener('keydown', function (e) {
      var idx = Array.prototype.indexOf.call(tabs, tab);
      var next = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (idx + 1) % tabs.length;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (idx - 1 + tabs.length) % tabs.length;
      if (next >= 0) {
        e.preventDefault();
        tabs[next].click();
        tabs[next].focus();
      }
    });
  });

  // Category selection
  catBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.category;
      catBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.category === key ? 'true' : 'false');
      });
      projects.forEach(function (card) {
        card.hidden = card.dataset.projectCategory !== key;
      });
      if (backBtn) backBtn.hidden = false;
    });
  });

  // Back button
  if (backBtn) {
    backBtn.addEventListener('click', function () {
      catBtns.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      projects.forEach(function (p) { p.hidden = true; });
      backBtn.hidden = true;
    });
  }

  // Focus trap
  function trapFocus(e) {
    if (overlay.hidden) return;
    var focusable = overlay.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  // Global listeners
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="#matrix"], [data-jbw-finder-open]');
    if (link) {
      e.preventDefault();
      open(link);
      return;
    }
    // Backdrop click
    if (!overlay.hidden && e.target === overlay) {
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) {
      close();
      return;
    }
    trapFocus(e);
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', close);
  }

  // Open on hash
  function checkHash() {
    if (location.hash === '#matrix') {
      open(null);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkHash);
  } else {
    checkHash();
  }

  // Re-init on section events
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.jbw-finder-overlay')) {
      overlay = e.target.querySelector('.jbw-finder-overlay');
    }
  });
})();
